module.exports = __webpack_public_path__ + "static/img/office (2).1c4989e7.jpg";